var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * 请求发送函数，融合axios和fetch
 * 1、可以通过create函数创建请求实例，fetch只支持'./fetchConfig'里标明的配置选项，如果配置其他选项，只能发axios请求
 * 2、可以直接导出get、post请求，但是直接导出的只支持发axios，但是会带上device id
 * 3、通过create函数创建的请求实例支持接入metrics监控，支持自定义配置参数和请求url
 */
import axios from 'axios';
import env from '../core/env';
import bridge from '../bridge/index';
import { handleFetchResponse, processFetchData } from './handleFetch';
import { getRequestMetricsParam } from './metrics';
import { fetchSupportConfig } from './fetchConfig';
import qs from 'qs';
var agent = axios.create();
var API_ORIGIN; // 请求默认域名
var needDeviceId = true; // 是否需要device id
var isReady; // 是否可以发送请求
var postList = []; // 后端已经处理过的复杂结构post请求（fetch需要）
var canUseFetchOverall = false; // 是否可以使用fetch发送请求
var processPostData = processFetchData;
/**
 * 通用参数，默认都带上b_Type 和 device_id
 */
var commonParams = {
    b_type_new: env.bType,
    device_id: 0
};
// 如果不可以使用 JSBFetch 方法，则在 commonParams 添加 is_outside 标示
if (!env.isInToutiaoProduct) {
    commonParams.is_outside = 1;
}
var requestQueue = [];
isReady = true;
if (env.isInToutiaoProduct && needDeviceId) {
    isReady = false;
    bridge
        .call('appInfo', {}, { timeout: 3000 })
        .then(function (info) {
        if (info && info.device_id) {
            commonParams.device_id = info.device_id;
        }
        commonParams.aid = (info && info.aid) || env.aid;
        isReady = true;
        requestQueue.splice(0).forEach(function (request) { return request(); });
    })
        .catch(function () {
        isReady = true;
        requestQueue.splice(0).forEach(function (request) { return request(); });
    });
}
/**
 * 判断是否存在fetch不支持的配置参数，如果有则用axios
 * @param config
 */
function getCanUseFetch(config) {
    if (!config)
        return true;
    var configs = Object.keys(config);
    var len = configs.length;
    for (var i = 0; i < len; i++) {
        if (fetchSupportConfig.indexOf(configs[i]) < 0) {
            return false;
        }
    }
    return true;
}
/**
 * 确定某一请求的具体发送方式 get
 * @param config
 */
function getGetRequestMethod(config) {
    if (canUseFetchOverall &&
        bridge.supports('fetch') &&
        getCanUseFetch(config)) {
        return fetchJsbMethodGet;
    }
    else {
        return agent.get;
    }
}
/**
 * 确定某一请求具体发送方式 post
 * @param config
 */
function getPostRequestMethod(config) {
    if (canUseFetchOverall &&
        bridge.supports('fetch') &&
        getCanUseFetch(config)) {
        return fetchJsbMethodPost;
    }
    else {
        return agent.post;
    }
}
/**
 * fetch发送请求
 * @param method 发送方法
 * @param data post data
 * @param url
 * @param config
 */
/* eslint-disable no-param-reassign */
function fetchJsbMethod(method, data, url, config) {
    if (data === void 0) { data = {}; }
    if (config === void 0) { config = {}; }
    var beforeTime = new Date().getTime();
    if (method === 'POST' && config.params) {
        if (url.indexOf('?') !== -1) {
            url = url + "&";
        }
        else {
            url = url + "?";
        }
        Object.keys(config.params).forEach(function (key) {
            url = "" + url + key + "=" + config.params[key] + "&";
        });
    }
    /* eslint-disable no-undefined */
    return bridge
        .call('fetch', {
        url: url,
        method: method,
        params: method === 'POST' ? {} : config.params,
        data: data,
        header: {},
        needCommonParams: true // 是否拼接通用参数, 默认false
    }, {
        timeout: method === 'GET' ? (config.timeout || 10000) / 2 : undefined
    })
        .then(function (response) {
        return handleFetchResponse(response, url, beforeTime);
    })
        .catch(function () {
        config.connectType = 'jsb_h5_req';
        return method === 'GET'
            ? agent.get(url, config)
            : agent.post(url, qs.stringify(data), config);
    });
}
/**
 * 检查post接口数据是否有复杂结构，且后端没有开发支持，如果有则进行报错
 * @param data
 * @param url
 */
function checkPostData(data, url) {
    var keys = Object.keys(data);
    var len = keys.length;
    for (var i = 0; i < len; i++) {
        if (Object.prototype.hasOwnProperty.call(data, keys[i]) &&
            typeof data[keys[i]] === 'object') {
            var dom = document.createElement('a');
            dom.href = url;
            var path = dom.pathname;
            if (postList && postList.indexOf(path) > -1) {
                data = processPostData(data);
            }
            else {
                throw new Error('backend need develop');
            }
            break;
        }
    }
    return data;
}
/**
 * 如果链接本身没有携带域名则会带上默认域名
 * @param url
 */
function wrapUrl(url) {
    if (!/^https?:\/\//i.test(url) && API_ORIGIN) {
        return API_ORIGIN + url;
    }
    return url;
}
/**
 * 用fetch发送get请求
 * @param url
 * @param config
 */
function fetchJsbMethodGet(url, config) {
    if (config === void 0) { config = {}; }
    url = wrapUrl(url);
    return fetchJsbMethod('GET', {}, url, config);
}
/**
 * 用fetch发送post请求
 * @param url
 * @param data
 * @param config
 */
function fetchJsbMethodPost(url, data, config) {
    if (config === void 0) { config = {}; }
    url = wrapUrl(url);
    data = checkPostData(data, url);
    return fetchJsbMethod('POST', data, url, config);
}
/**
 * 参数处理
 * @param config
 */
function mergeConfig(config) {
    var params = __assign({}, commonParams);
    var result = __assign({}, config);
    result.params = Object.assign(params, result.params);
    return result;
}
export var pureAxios = axios.create();
/**
 * 创建请求实例
 * @param config
 */
export var create = function (config) {
    if (config === void 0) { config = {}; }
    agent = axios.create(config);
    canUseFetchOverall = getCanUseFetch(config);
    if (config) {
        API_ORIGIN = config.baseURL;
        postList = config.postList || [];
        if (config.commonParams) {
            commonParams = Object.assign(commonParams, config.commonParams);
        }
        if (Object.prototype.hasOwnProperty.call(config, 'needDeviceId')) {
            needDeviceId = config.needDeviceId;
        }
        if (Object.prototype.hasOwnProperty.call(config, 'processPostData') &&
            typeof config.processPostData === 'function') {
            processPostData = config.processPostData;
        }
    }
    // 请求发送前处理
    agent.interceptors.request.use(function (config) {
        config.beforeTime = new Date().getTime();
        return config;
    }, function (error) {
        return Promise.reject(error);
    });
    // 请求返回后处理
    agent.interceptors.response.use(function (response) {
        var afterTime = new Date().getTime();
        setTimeout(function () { return getRequestMetricsParam(response, afterTime); }, 0);
        return response;
    }, function (error) {
        var afterTime = new Date().getTime();
        setTimeout(function () { return getRequestMetricsParam(error, afterTime); }, 0);
        return Promise.reject(error);
    });
};
/**
 * 如果没有creat，直接导出get和post会默认加上DeviceId，调用axios，不会走fetch
 * @param url
 * @param config
 */
export var get = function (url, config) {
    var processFunc = getGetRequestMethod(config);
    if (isReady) {
        return processFunc(url, mergeConfig(config));
    }
    return new Promise(function (resolve, reject) {
        requestQueue.push(function () {
            processFunc(url, mergeConfig(config)).then(resolve, reject);
        });
    });
};
export var post = function (url, data, config) {
    var processFunc = getPostRequestMethod(config);
    var payload = typeof data === 'string' || processFunc === fetchJsbMethodPost
        ? data
        : qs.stringify(data);
    if (isReady) {
        return processFunc(url, payload, mergeConfig(config));
    }
    return new Promise(function (resolve, reject) {
        requestQueue.push(function () {
            processFunc(url, payload, mergeConfig(config)).then(resolve, reject);
        });
    });
};
